import React from 'react';
import DischargeList_Tabs from "./Tabs/DischargeList_Tabs";
import AdvancedList_Search from "../AdvancedList/AdvancedList_Search";
import useSortableData from "../../utils/sortableData";
import useAdmissionListNavigation from "../../utils/admissionListNavigation";
import {useSelector} from "react-redux";
import useFilteredData from "../../utils/subfilteredData";
import {DischargeList_Item_Memo} from "./Item/DischargeList_Item";
import DischargeList_SortHeaders from "./DischargeList_SortHeaders";

const DischargeList = () => {
    const {pushAdmissionsListUrl} = useAdmissionListNavigation();
    const {admissions, sortColumn, sortMode, totalPages, dev_suggestedDischargeDate, dev_noDischargeData} = useSelector(state => state.dischargeList);
    const state_showDevUI = useSelector(state => state.auth.state_showDevUI);
    const selectedHospital = useSelector(state => state.auth.selectedHospital);
    const {filteredItems} = useFilteredData(admissions);
    const { items, requestSort, getClassNamesFor } = useSortableData(pushAdmissionsListUrl, filteredItems, {key: sortColumn, direction: sortMode});

    const renderRow = (admission, key) => <DischargeList_Item_Memo key={key} admission={admission}/>

    // Dev-only hint: when the current view has no discharged admissions, either point to the most
    // recent date that does, or - when the hospital has no discharged admissions at all - say so,
    // so testers don't have to guess which dates have data.
    const renderDevSuggestedDate = () => {
        if (!state_showDevUI) {
            return null;
        }
        if (dev_suggestedDischargeDate) {
            return (
                <div className="alert alert-info">
                    No discharged admissions on selected date. <a href={`/discharge/${selectedHospital.id}/${dev_suggestedDischargeDate}`}>Go to {dev_suggestedDischargeDate}</a>
                </div>
            );
        }
        if (dev_noDischargeData) {
            return (
                <div className="alert alert-warning">
                    No admissions have a discharge date yet.
                </div>
            );
        }
        return null;
    }

    return (
        <main className="main">
            <div className="container container1072">
                <div className="row justify-content-center">
                    <div className="col-12">
                        <h1 className="h2">Discharge List</h1>
                        {renderDevSuggestedDate()}
                        <div className="table-holder bg-white rounded shadow-sm border">
                            <DischargeList_Tabs />
                            {/*{devIsPagerDisabled && <AdmissionList_SubFilter />}*/}
                            <div className="tab-content">
                                <div className="tab-pane fade show active" id="tab1" role="tabpanel"
                                     aria-labelledby="tab1">
                                    <AdvancedList_Search />
                                    <table className="table procedure-list-table" cellSpacing="0" width="100%">
                                        <DischargeList_SortHeaders _requestSort={requestSort} _getClassNamesFor={getClassNamesFor}/>
                                        <tbody>
                                        {items.map(renderRow)}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
}

export default DischargeList;